const workspaceConfigActionTypes = {
  SET_WORKSPACE_CONFIG: 'SET_WORKSPACE_CONFIG',
};
export default workspaceConfigActionTypes;
